import React,{useState, useEffect} from 'react';
import FondoColor from '../../FondoImagenes/Banner';
import {Carousel, Container} from 'react-bootstrap';
import {GetSlidesApi} from '../../../api/slide';
import Slide1 from '../../../assets/png/slideTemporales/ejemplo1.jpg';
import './Banner.scss';

const Banner = () => {
  const [galeria, setGaleria] = useState(null);
  
useEffect(() => {
  (async () =>{
    const response = await GetSlidesApi();
    setGaleria(response.slide);
  })()
}, []);
    return (
      <div  id='Home'>
<FondoColor
      body={
        <Container>
          {
            (galeria?.length === 0 || galeria === undefined)?
            <Carousel>
            <Carousel.Item>
              <img
                src={Slide1}
                className='slide__img'
                alt="First slide"
              />
            </Carousel.Item>
          </Carousel> :
          <Carousel>
            {
          galeria?.map((item) =>{
            return(
              <Carousel.Item>
                <img
                  src={item?.imagen}
                  className='slide__img'
                  alt="First slide"
                />
              </Carousel.Item>
            )
          })
        }
          </Carousel>
          }
</Container>
      
      
      }
      />
      </div>
    );
}

export default Banner;
